import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Signup from './pages/Signup';
import HowItWorks from './pages/HowItWorks';
import Services from './pages/Services';
import Security from './pages/Security';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import AdminControlPanel from './pages/AdminControlPanel';
import AdminDashboard from './pages/AdminDashboard';   // ✅ new
import AdminLogin from './pages/AdminLogin';           // ✅ new
import AssetVault from './pages/AssetVault';
import ReleaseManagement from './pages/ReleaseManagement';
import Cases from './pages/Cases';
import VaultOverview from './pages/VaultOverview';
import Reports from './pages/Reports';
import Transactions from './pages/Transactions';
import VerificationCenter from './pages/VerificationCenter';
import SecurityCenter from './pages/SecurityCenter';
import Settings from './pages/Settings';
import Support from './pages/Support';
import Logout from './pages/Logout';
import AdminKYC from './pages/AdminKYC';
import AdminTickets from './pages/AdminTickets';
import AdminLogs from './pages/AdminLogs';
import Send from './pages/Send';
import AdminWithdrawals from './pages/AdminWithdrawals';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import VerifyEmail from './pages/VerifyEmail';

// ── Route Guards ─────────────────────────────────
function PrivateRoute({ children }) {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" />;
}

function AdminRoute({ children }) {
  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  // ✅ Redirect to admin login, not regular login
  return token && user.role === 'admin' ? children : <Navigate to="/admin-login" />;
}

// ── Layout Helpers ───────────────────────────────
function PrivateLayout({ children }) {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  return <Layout key={user.id}>{children}</Layout>;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* ── Public ── */}
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/admin-login" element={<AdminLogin />} />   {/* ✅ admin login */}
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/services" element={<Services />} />
        <Route path="/security" element={<Security />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />

        {/* ── User Dashboard (all logged‑in users) ── */}
        <Route path="/dashboard" element={
          <PrivateRoute>
            <PrivateLayout><Dashboard /></PrivateLayout>
          </PrivateRoute>
        } />

        {/* ── Other user protected pages ── */}
        <Route path="/vault" element={
          <PrivateRoute><PrivateLayout><AssetVault /></PrivateLayout></PrivateRoute>
        } />
        <Route path="/send" element={
          <PrivateRoute><PrivateLayout><Send /></PrivateLayout></PrivateRoute>
        } />
        <Route path="/vault-overview" element={
          <PrivateRoute><PrivateLayout><VaultOverview /></PrivateLayout></PrivateRoute>
        } />
        <Route path="/releases" element={
          <PrivateRoute><PrivateLayout><ReleaseManagement /></PrivateLayout></PrivateRoute>
        } />
        <Route path="/cases" element={
          <PrivateRoute><PrivateLayout><Cases /></PrivateLayout></PrivateRoute>
        } />
        <Route path="/transactions" element={
          <PrivateRoute><PrivateLayout><Transactions /></PrivateLayout></PrivateRoute>
        } />
        <Route path="/verification" element={
          <PrivateRoute><PrivateLayout><VerificationCenter /></PrivateLayout></PrivateRoute>
        } />
        <Route path="/security-center" element={
          <PrivateRoute><PrivateLayout><SecurityCenter /></PrivateLayout></PrivateRoute>
        } />
        <Route path="/reports" element={
          <PrivateRoute><PrivateLayout><Reports /></PrivateLayout></PrivateRoute>
        } />
        <Route path="/settings" element={
          <PrivateRoute><PrivateLayout><Settings /></PrivateLayout></PrivateRoute>
        } />
        <Route path="/support" element={
          <PrivateRoute><PrivateLayout><Support /></PrivateLayout></PrivateRoute>
        } />

        {/* ── Admin Dashboard (new) ── */}
        <Route path="/admin/dashboard" element={
          <AdminRoute>
            <PrivateLayout><AdminDashboard /></PrivateLayout>
          </AdminRoute>
        } />

        {/* ── Admin User Management (old control panel) ── */}
        <Route path="/admin/users" element={
          <AdminRoute>
            <PrivateLayout><AdminControlPanel /></PrivateLayout>
          </AdminRoute>
        } />

        {/* ── Other admin tools ── */}
        <Route path="/admin/kyc" element={
          <AdminRoute><PrivateLayout><AdminKYC /></PrivateLayout></AdminRoute>
        } />
        <Route path="/admin/tickets" element={
          <AdminRoute><PrivateLayout><AdminTickets /></PrivateLayout></AdminRoute>
        } />
        <Route path="/admin/logs" element={
          <AdminRoute><PrivateLayout><AdminLogs /></PrivateLayout></AdminRoute>
        } />
        <Route path="/admin/withdrawals" element={
          <AdminRoute><PrivateLayout><AdminWithdrawals /></PrivateLayout></AdminRoute>
        } />

        <Route path="/logout" element={<Logout />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
